// eslint-disable-next-line max-len
export const addressRegex = /^(([a-zA-z]+[pP][oO])|(?![pP]+[\s|\\.\-,]*[oO]+[\s|\\.\-,#]+|[pP][oO][bB][oO][xX]|[pP][oO][sS][tT][\s|\\.\-,]*([oO][fF]+[iI][cC][eE]|[bB][oO][xX])|[oO][fF]+[iI][cC][eE][\\s|\\.\-,]*[bB][oO][xX]).)*$/;
export const phoneRegex = /^(\([0-9]{3}\) [0-9]{3}-[0-9]{4})$|^([0-9]{10})$/;
// eslint-disable-next-line max-len,no-useless-escape
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const zipCodeRegex = /^[0-9]{5}$/;
export const containsLettersRegex = /^(.*[a-zA-Z].*)$/;
export const notEmptyRegex = /.+/;
